import { useParams, useLocation } from "react-router-dom";
import EditLayout from "../layout/EditLayout";

function EditView() {
  const { objectName, id } = useParams();
  const location = useLocation();
  
  // Determine source page from URL or state
  let sourcePage = 'listview'; // default
  
  // First check if sourcePage is explicitly set in state
  if (location.state?.sourcePage) {
    sourcePage = location.state.sourcePage;
  } else if (location.state?.from) {
    sourcePage = location.state.from;
  } else {
    // Try to determine from referrer or URL pattern
    const referrer = document.referrer;
    if (referrer.includes('/view/') || referrer.includes('/detail/')) {
      sourcePage = 'detail';
    } else if (referrer.includes('/listview/') || referrer.includes('/list/')) {
      sourcePage = 'listview';
    }
  }
  
  // Extract query parameters for pre-population
  const searchParams = new URLSearchParams(location.search);
  const targetfield = searchParams.get('targetfield');
  const targetid = searchParams.get('targetid');
  
  console.log('EditView - Query parameters:', { targetfield, targetid });
  
  // Create pre-population params object if both parameters are present
  const prePopulateParams = (targetfield && targetid) ? {
    targetField: targetfield,
    targetId: targetid
  } : null;
  
  console.log('EditView - Pre-population params:', prePopulateParams);
  console.log("Object Edit Wrapper-->", { objectName, id, sourcePage });
  
  return <EditLayout 
    objectName={objectName} 
    id={id} 
    sourcePage={sourcePage}
    queryParams={prePopulateParams}
  />;
}
export default EditView;
